


























































import {Component, Prop, Vue} from 'vue-property-decorator';
import Address from "@/api/Address";

@Component
export default class RenderAddress extends Vue {
  @Prop() private address!: Address;
  @Prop({default: true}) private showMapLink!: boolean;
}
